<template>
  <section class="topstyle">
    <div class="operationBox">
      <div>
        <p>课程类型</p>
        <el-select
          v-model="filters.CourseTypeId"
          placeholder="请选择课程类型"
          style="width: 200px; margin: 0px auto 10px 15px"
          @change="GetCoursesTypeAdmin()"
        >
          <el-option
            v-for="(item, index) in coursetypelist"
            :key="index"
            :label="item.Name"
            :value="item.Id"
          ></el-option>
        </el-select>
      </div>

      <div>
        <p>课程专题</p>
        <el-select
          v-model="filters.CourseTypeIdTwo"
          placeholder="请选择课程专题"
          style="width: 200px; margin: 0px auto 10px 15px"
        >
          <!--  @change="selectGetlist()" -->
          <el-option
            v-for="(item, index) in coursetypelistTwo"
            :key="index"
            :label="item.Name"
            :value="item.Id"
          ></el-option>
        </el-select>
      </div>
      <div>
        <p>是否线上</p>
        <el-select
          v-model="filters.isLine"
          placeholder="是否线上"
          style="width: 200px; margin: 0px auto 10px 15px"
        >
          <!-- @change="GetCoursesTypeAdmin()" -->
          <el-option
            v-for="(item, index) in lineListnumber"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
      <!--工具条-->
      <toolbar
        placeholder="请输入课程标题"
        :buttonList="buttonList"
        @callFunction="callFunction"
        style="margin: 10px auto 0px 15px; width: 600px"
      ></toolbar>
    </div>

    <!-- 筛选框 -->
    <!-- <el-select
      id="inputselect"
      v-model="filters.CourseTypeId"
      placeholder="请选择类型"
      style="width: 200px; margin: 0px auto 10px 15px"
      @change="selectGetlist()"
    >
      <el-option
        v-for="(item, index) in coursetypelist"
        :key="index"
        :label="item.Name"
        :value="item.Id"
      ></el-option>
    </el-select> -->

    <!--列表-->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="margin: 10px auto 0px 15px; border: 1px #eaeaea solid"
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        label=" "
        align="center"
      ></el-table-column>

      <el-table-column
        prop="HostName"
        label="课程类型"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CourseTypeName"
        label="课程专题"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column prop="" label="线上/线下" align="center" sortable>
        <template slot-scope="scope">
          {{ scope.row.TaskType == 1 ? "线下" : "线上" }}
        </template></el-table-column
      >
      <el-table-column prop="" label="属性" align="center" sortable>
        <template slot-scope="scope">
          {{
            scope.row.TaskType == 0
              ? "课程"
              : scope.row.TaskType == 1
              ? "活动"
              : "文章"
          }}
        </template></el-table-column
      >
      <el-table-column
        prop="Name"
        label="课程标题"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column prop="ListImg" label="封面" align="center" sortable>
        <template slot-scope="scope">
          <div>
            <el-image
              :src="scope.row.ListImg"
              fit="contain"
              @click.native="Logimg.push(scope.row.ListImg)"
            >
            </el-image>
          </div>
        </template>
        <!-- 图片的显示 -->
      </el-table-column>
      <el-table-column
        prop="Score"
        label="分数"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column prop="Status" label="是否发布" align="center" sortable>
        <template slot-scope="scope">
          {{ scope.row.Status == 2 ? "已发" : "未发" }}
        </template></el-table-column
      >
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        :formatter="formatCreateTime"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.TaskType == 0"
            size="mini"
            type="primary"
            @click="onLookDatas(scope.row.Id)"
            >课程目录</el-button
          >
          <el-tag
            v-if="scope.row.TaskType == 2"
            type="success"
            disable-transitions
            >文章
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200px" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.TaskType == 1"
            class="SpanList"
            @click="creatQrCode(scope.row.IdentifierOne, scope.row.Id)"
            >查看二维码</span
          >
          <!-- <span class="SpanList" @click="creatQrCode(scope.row.CourseTypeName,scope.row.Id)">查看二维码</span> -->
          <span
            class="SpanList"
            @click="
              handleEdit(
                scope.row,
                scope.row.Id,
                scope.row.TaskType,
                scope.row.HostName
              )
            "
            >编辑</span
          >
          <span
            class="SpanList"
            @click="handleDel(scope.row.Id, scope.row.TaskType)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        style="margin-top: 20px"
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="5"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      @opened="Editwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          编辑
          <img
            @click="DialogDown()"
            style="float: right; width: 20px; height:20px font-size: 20px; cursor: pointer;padding-top:15px;padding-right:20px"
            src="../../assets/close.png"
            alt=""
          />

          <!-- <span
           
           
            >x</span
          > -->
        </h2>
      </span>
      <el-form
        :model="editForm"
        label-width="90px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="课程类别" prop="Name">
          <el-input v-model="HostName" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="课程标题" prop="Name">
          <el-input v-model="editForm.Name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="课程专题">
          <el-select
            v-model="editForm.CourseTypeId"
            placeholder="请选择课程分类"
          >
            <el-option
              v-for="(item, index) in coursetypelistTwo"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img
              v-if="editForm.ListImg"
              :src="editForm.ListImg"
              class="avatar"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>

        <!-- <el-form-item label="分数" prop="Stroc">
          <el-input-number
            :min="0"
            v-model="editForm.Stroc"
            auto-complete="off"
          ></el-input-number>
        </el-form-item> -->

        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="editForm.Status" placeholder="请选择状态">
            <el-option
              v-for="(item, index) in Statuslist"
              :label="item.Name"
              :value="item.Status"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 线上课程 -->
        <div v-show="isLine && isCourse">
          <!-- <el-form-item label="简介" prop="Briefing" v-if="editForm.Istrue">
          <el-input type="textarea" v-model="editForm.Briefing"></el-input>
        </el-form-item> -->
          <el-form-item label="课程简介" prop="Briefing">
            <el-input type="textarea" v-model="editForm.Briefing"></el-input>
          </el-form-item>
        </div>
        <!-- 线上文章 -->
        <div v-show="isLine && !isCourse">
          <el-form-item label="文章详情" prop="Detail">
            <div class="edit_container" id="Edit_container"></div>
          </el-form-item>
        </div>
        <!-- 线下 -->
        <div v-show="!isLine">
          <el-form-item label="活动介绍" prop="Detail">
            <div class="edit_container" id="Edit_container_details"></div>
          </el-form-item>
          <el-form-item label="活动流程" prop="Detail">
            <div class="edit_container" id="Edit_container_flow"></div>
          </el-form-item>
          <el-form-item label="活动地点" prop="Detail">
            <el-select
              v-model="address"
              placeholder="活动地址"
              style="width: 200px; margin: 0px auto 10px 15px"
            >
              <el-option
                v-for="(item, index) in addressList"
                :key="index"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editNewSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->

    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      @opened="Addwangeditor()"
      custom-class="subTitle"
      :show-close="false"
    >
      <span slot="title">
        <h2>
          创建课程
          <img
            @click="DialogDown()"
            style="float: right; width: 20px; height:20px font-size: 20px; cursor: pointer;padding-top:15px;padding-right:20px"
            src="../../assets/close.png"
            alt=""
          />
        </h2>
      </span>
      <el-form
        :model="addForm"
        label-width="90px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="课程专题">
          <el-select
            v-model="addForm.CourseHostTypeId"
            placeholder="请选择课程分类"
            @change="AddGetCoursesTypeAdmin()"
          >
            <el-option
              v-for="(item, index) in coursetypelist"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- @change="AddGetCoursesTypeOnewAdmin()" -->
        <el-form-item label="课程专题">
          <el-select
            v-model="addForm.CourseTypeId"
            placeholder="请选择课程专题"
          >
            <el-option
              v-for="(item, index) in coursetypelistTwo"
              :key="index"
              :label="item.Name"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <div class="btnBox">
          <el-button
            v-if="this.CurriculumTypenumber == 1"
            :type="this.CurriculumTypenumber != 0 ? 'primary' : 'default'"
            >线上</el-button
          >
          <el-button
            v-if="this.CurriculumTypenumber == 2"
            :type="this.CurriculumTypenumber != 0 ? 'primary' : 'default'"
            >线下</el-button
          >
        </div>
        <div class="btnBox" v-if="isLine">
          <el-button
            :type="isCourse ? 'primary' : 'default'"
            @click="checkCourse(true)"
            >课程</el-button
          >
          <el-button
            :type="!isCourse ? 'primary' : 'default'"
            @click="checkCourse(false)"
            >文章</el-button
          >
        </div>
        <el-form-item label="课程标题">
          <el-input type="input" v-model="addForm.Name"></el-input>
        </el-form-item>
        <el-form-item label="封面图片">
          <el-upload
            class="avatar-uploader"
            action=""
            :show-file-list="false"
            width="450"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
            :http-request="uploadFile"
          >
            <img v-if="addForm.ListImg" :src="addForm.ListImg" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- 线上课程 -->
        <div v-show="isLine && isCourse">
          <el-form-item label="课程简介" prop="Briefing">
            <el-input type="textarea" v-model="addForm.Briefing"></el-input>
          </el-form-item>
        </div>
        <!-- 线上文章 -->
        <div v-show="isLine && !isCourse">
          <el-form-item label="文章详情" prop="Detail">
            <div class="edit_container" id="Add_container"></div>
          </el-form-item>
        </div>
        <!-- 线下 -->
        <div v-show="!isLine && this.CurriculumTypenumber == 2">
          <el-form-item label="活动介绍" prop="Detail">
            <div class="edit_container" id="Add_container_details"></div>
          </el-form-item>
          <el-form-item label="活动流程" prop="Detail">
            <div class="edit_container" id="Add_container_flow"></div>
          </el-form-item>
          <el-form-item label="活动地点" prop="Detail">
            <el-select
              v-model="address"
              placeholder="活动地址"
              style="width: 200px; margin: 0px auto 10px 15px"
            >
              <el-option
                v-for="(item, index) in addressList"
                :key="index"
                :label="item.Name"
                :value="item.Id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <!-- <el-form-item label="分数" prop="Stroc">
          <el-input-number
            :min="0"
            v-model="addForm.Stroc"
            auto-complete="off"
          ></el-input-number>
        </el-form-item> -->
        <el-form-item label="是否发布" prop="Status">
          <el-select v-model="addForm.Status" placeholder="请选择状态">
            <el-option label="发布" value="2"></el-option>
            <el-option label="草稿" value="1"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addNewSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <creatqrcodes
      @closedCodes="closedFnShow"
      :isShowCodes="isShowCodesStatus"
      :Codesvalue="Codesvaluesigin"
      :CodesvalueType="CodesvalueTypeSigin"
    />
  </section>
</template>

<script>
import util from "../../../util/date";
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import {
  getcourseListPage,
  getcoursetypes,
  addcourses,
  UploadImg,
  coursedelete,
  getcoursesingle,
  backcourseupdate,
  GetArticlesSingle,
  UpdateArticles,
  GetHostCoursesData,
  GetCoursesTypeAdmin,
  activitiessingle,
  activitiesadd,
  activitiesedit,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import E from "wangeditor";
// import QRCode from "qrcodejs2";
import creatqrcodes from "../../components/creatqrcodes";

export default {
  components: { Toolbar, quillEditor, creatqrcodes },
  data() {
    return {
      CurriculumTypenumber: 0,
      HostName: "",
      Codesvaluesigin: "",
      CodesvalueTypeSigin: 0,
      isShowCodesStatus: false,
      editor: null,
      editor_details: null,
      editor_flow: null,
      Logimg: [],
      editorOption: {},
      dialogVisible: false,
      formLabelWidth: "80px",
      limitNum: 1,
      buttonList: [],
      coursetypelist: [],
      coursetypelistTwo: [],
      isLine: false, //是否是线上
      isCourse: true, //是否是课程
      address: "校内",
      addressList: [
        {
          name: "校内",
          Id: "校内",
        },
        {
          name: "校外",
          Id: "校外",
        },
      ],
      lineList: [
        {
          label: "线上",
          value: true,
        },
        {
          label: "线下",
          value: false,
        },
      ],
      lineListnumber: [
        {
          label: "全部",
          value: 0,
        },
        {
          label: "线上",
          value: 1,
        },
        {
          label: "线下",
          value: 2,
        },
      ],
      Sticklist: [
        { Id: 1, Name: "是", IsStick: true },
        { Id: 2, Name: "否", IsStick: false },
      ],
      Statuslist: [
        { Id: 1, Name: "发布", Status: 2 },
        { Id: 2, Name: "草稿", Status: 1 },
      ],
      currentRow: null,
      filters: {
        Title: "",
        searchCourseTypeId: null, //搜索专用
        CourseTypeId: null, //一级分类
        CourseTypeIdTwo: null, //二级分类
        isLine: 0,
      },
      users: [],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        CourseTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        // Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        // Detail: [{ required: true, message: "详情", trigger: "blur" }],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],

        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        CourseTypeId: [{ required: true, message: "未选择", trigger: "blur" }],
        Stroc: [{ required: true, message: "分数", trigger: "blur" }],
      },
      //编辑界面数据
      editForm: {
        Id: 0,
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        IsStick: false,
        ListImg: "",
        Status: null,
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        Name: [{ required: true, message: "请输入课程标题", trigger: "blur" }],
        CourseTypeId: [
          { required: true, message: "课程类型", trigger: "blur" },
        ],
        // Briefing: [{ required: true, message: "简介", trigger: "blur" }],
        // Detail: [{ required: true, message: "详情", trigger: "blur" }],
        ListImg: [{ required: true, message: "图片", trigger: "blur" }],
        // IsStick: [{ required: true, message: "未选择", trigger: "blur" }],
        Status: [{ required: true, message: "未选择", trigger: "blur" }],
        CourseTypeId: [{ required: true, message: "未选择", trigger: "blur" }],
      },
      //新增界面数据
      addForm: {
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        Detail_flow: "",
        IsStick: false,
        ListImg: "",
        Status: null,
        Istrue: null,
        Stroc: 0,
        CourseHostTypeId: null,
      },
    };
  },
  methods: {
    ///清空筛选
    handleEmpty() {
      this.filters.CourseTypeId = null;
      this.filters.isLine = null;
      this.filters.CourseTypeIdTwo = null;
      this.getLists();
      this.coursetypelistTwo = [];
    },
    closedFnShow() {
      this.$set(this, "isShowCodesStatus", false);
    },
    creatQrCode(value, type) {
      console.log(value, "value ");
      this.Codesvaluesigin = value;
      this.CodesvalueTypeSigin = type;
      this.$set(this, "isShowCodesStatus", true);
    },
    checkLine(flag) {
      console.log("checkLine", this.filters.CourseTypeId);
      this.isLine = flag;
      GetCoursesTypeAdmin({
        Type: this.filters.CourseTypeId,
        online: 0,
      }).then((res) => {
        if (res.data.success && res.data.response.length != 0) {
          this.coursetypelistTwo = res.data.response;
          this.coursetypelistTwo.reverse();
          this.addForm.CourseTypeId = res.data.response[0].Id;
          // this.filters.CourseTypeIdTwo = res.data.response[0].Id;
        } else {
          this.coursetypelistTwo = [];
          this.addForm.CourseTypeId = null;
        }
      });
    },
    checkCourse(flag) {
      console.log("checkCourse");
      this.isCourse = flag;
      console.log("ces1", this.isLine);
      GetCoursesTypeAdmin({
        Type: this.filters.CourseTypeId,
        online: 0,
      }).then((res) => {
        if (res.data.success && res.data.response.length != 0) {
          this.coursetypelistTwo = res.data.response;
          this.coursetypelistTwo.reverse();
          this.addForm.CourseTypeId = res.data.response[0].Id;
          //  this.filters.CourseTypeIdTwo = res.data.response[0].Id;
        } else {
          this.coursetypelistTwo = [];
          this.addForm.CourseTypeId = null;
        }
      });
    },
    selectGetlist() {
      this.page = 1;
      this.getLists();
    },
    closedFnShow() {
      this.$set(this, "isShowCodesStatus", false);
    },
    // creatQrCode(value, type) {
    //   this.Codesvaluesigin = value;
    //   this.CodesvalueTypeSigin = type;
    //   this.$set(this, "isShowCodesStatus", true);
    // },
    // 查看数据
    onLookDatas(id) {
      //this.$router.push('/Course/courseData_index')

      this.$router.push({
        path: "/Course/courseData_index",
        query: { Id: id },
      });
    },
    onEditorReady(editor) {},
    // 上传文件之前的钩子
    handleAvatarSuccess(res, file) {
      this.addForm.ListImg = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
      if (
        !(
          file.type === "image/png" ||
          file.type === "image/gif" ||
          file.type === "image/jpg" ||
          file.type === "image/jpeg"
        )
      ) {
        this.$notify.warning({
          title: "警告",
          message:
            "请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片",
        });
      }
      let size = file.size / 1024 / 1024 / 2;
      if (size > 2) {
        this.$notify.warning({
          title: "警告",
          message: "图片大小必须小于2M",
        });
      }
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadImg(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        if (response.data.success) {
          this.addForm.ListImg = response.data.response;
          this.editForm.ListImg = response.data.response;
          console.log("filename", this.addForm.ListImg);
          this.$message.info("文件：" + fileObj.name + "上传成功");
        } else {
          this.$message.info("文件：" + fileObj.name + "上传失败");
        }
      });
    },
    ///新增/修改
    AddGetCoursesTypeAdmin() {
      this.filters.CourseTypeId = this.addForm.CourseHostTypeId;
      GetCoursesTypeAdmin({
        Type: this.addForm.CourseHostTypeId,
        online: 0,
      }).then((res) => {
        if (res.data.success && res.data.response.length != 0) {
          this.coursetypelistTwo = res.data.response;
          this.coursetypelistTwo.reverse();
          this.addForm.CourseTypeId = res.data.response[0].Id;
          this.CurriculumTypenumber = res.data.response[0].CurriculumType;
          console.log(this.CurriculumTypenumber, "CurriculumTypenumber");
          if (this.CurriculumTypenumber == 1) {
            this.checkLine(true);
          } else {
            this.checkLine(false);
          }
        } else {
          this.coursetypelistTwo = [];
          this.addForm.CourseTypeId = null;
        }
      });
    },
    AddGetCoursesTypeOnewAdmin() {
      this.CurriculumTypenumber = this.coursetypelistTwo.filter((x) => {
        return x.Id == this.addForm.CourseTypeId;
      })[0].CurriculumType;
      if (this.CurriculumTypenumber == 1) {
        this.checkLine(true);
      } else {
        this.checkLine(false);
      }
    },
    // 获取二级课程列表
    GetCoursesTypeAdmin() {
      console.log(this.filters.CourseTypeId, "this.filters.CourseTypeId");
      if (!this.filters.CourseTypeId) {
        return;
      }
      console.log(this.filters, "this.filters");
      GetCoursesTypeAdmin({
        Type: this.filters.CourseTypeId,
        online: this.filters.isLine == null ? 0 : this.filters.isLine,
      }).then((res) => {
        if (res.data.success && res.data.response.length != 0) {
          this.coursetypelistTwo = res.data.response;
          this.coursetypelistTwo.reverse();
          this.filters.CourseTypeIdTwo = res.data.response[0].Id;
          // this.selectGetlist();
        } else {
          this.coursetypelistTwo = [];
          this.filters.CourseTypeIdTwo = "";
          // this.selectGetlist();
        }
      });
    },
    // 获取课程列表
    GetHostCoursesData() {
      GetHostCoursesData().then((res) => {
        if (res.data.success) {
          this.coursetypelist = res.data.response;
          this.coursetypelist.reverse();
          // this.filters.CourseTypeId = res.data.response[0].Id;
          //  this.GetCoursesTypeAdmin();
        } else {
          this.coursetypelist = [];
          this.filters.CourseTypeId = null;
        }
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    getModules() {
      console.log("qingqiu");
      this.page = 1;
      this.getLists();
    },
    callFunction(item) {
      this.filters.name = item.search;
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatbcontent: function (row, column) {
      return row.bcontent ? row.bcontent.substring(20) : "N/A";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd hh:mm");
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getLists();
    },
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    //获取列表
    getLists() {
      // let para = {
      //   PageIndex: this.page,
      //   Title: this.filters.name,
      //   CourseTypeId: this.filters.CourseTypeId,
      // };
      let para = {
        PageIndex: this.page,
        Title: this.filters.name,
        HostTypeID: this.filters.CourseTypeId,
        CourseTypeId: this.filters.CourseTypeIdTwo,
        IsOnline: this.filters.isLine,
      };
      this.listLoading = true;
      getcourseListPage(para).then((res) => {
        if (res.data.success) {
          this.AddRecordInfo("查询", "课程管理-查看课程列表");
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
        }
      });
    },
    //删除
    handleDel(id, TaskType) {
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: id, TaskType: TaskType };
          coursedelete(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.AddRecordInfo("删除", "课程管理-删除课程列表");

              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getLists();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(row, id, type, HostName) {
      //console.log(row,"row")
      this.filters.CourseTypeId = row.TypeId;
      this.HostName = HostName;
      // 课程
      if (type == 0) {
        this.checkLine(true);
        this.checkCourse(true);
        //线上
        this.isLine = true;
        //课程
        this.isCourse = true;
        this.editForm = {
          Id: null,
          CourseTypeId: null,
          Name: null,
          Detail: null,
          IsStick: false,
          ListImg: null,
          Status: null,
          Briefing: null,
          Istrue: null,
          Stroc: 0,
          type: 2,
        };
        getcoursesingle({ CourseId: id }).then((res) => {
          if (res.data.success) {
            // this.getcoursetypelist();
            this.editFormVisible = true;
            let editFormdata = res.data.response;
            console.log(editFormdata);
            this.editForm = {
              Id: editFormdata.Id,
              Briefing: editFormdata.Briefing,
              CourseTypeId: editFormdata.CourseTypeId,
              Name: editFormdata.Name,
              Detail: editFormdata.Detail,
              IsStick: false,
              ListImg: editFormdata.ListImg,
              Status: editFormdata.Status,
              Istrue: true,
              Stroc: editFormdata.Stroc,
              type: 2,
            };
            console.log(this.editForm);
            console.log(this.coursetypelistTwo, "测试");
            this.editForm.Istrue = true;
            this.$nextTick(() => {
              this.$refs["editForm"].clearValidate();
            });
          }
        });
        return;
      }
      // 活动
      if (type == 1) {
        this.checkLine(false);
        //线下
        this.isLine = false;
        activitiessingle({ Id: id, type: 1 }).then((res) => {
          if (res.data.success) {
            //this.getcoursetypelist();
            this.editFormVisible = true;
            let data = {
              ...res.data.response.data,
              Stroc: res.data.response.Stroc,
            };
            this.editForm = {
              Id: data.Id,
              CourseTypeId: data.ActivityTypeId,
              Name: data.Name,
              Detail: data.Detail,
              ListImg: data.ListImg,
              Status: data.Status,
              Stroc: data.Stroc,
              Notice: data.Notice,
              Address: data.Address,
            };
            console.log(this.editForm);
            console.log(this.coursetypelistTwo, "测试");
            // this.$set(this, "editForm", res.data.response.data);
            this.$nextTick(() => {
              this.$refs["editForm"].clearValidate();
            });
          }
        });
      }
      // 文章
      if (type == 2) {
        this.checkLine(true);
        this.checkCourse(false);
        //线上
        this.isLine = true;
        //文章
        this.isCourse = false;
        (this.editForm = {
          Id: null,
          CourseTypeId: null,
          Name: null,
          Detail: null,
          IsStick: false,
          ListImg: null,
          Status: null,
          Briefing: null,
          Istrue: null,
          Stroc: 0,
          type: 2,
        }),
          GetArticlesSingle({ id: id, types: 1 }).then((res) => {
            if (res.data.success) {
              // this.getcoursetypelist();
              this.editFormVisible = true;
              let resdata = res.data.response;
              this.editForm.Istrue = false;
              console.log(resdata);
              this.editForm = {
                Id: resdata.Id,
                CourseTypeId: resdata.ArticleTypeId,
                Name: resdata.Title,
                Detail: resdata.Content,
                IsStick: false,
                ListImg: resdata.ListImg,
                Status: resdata.ArticleStatus,
                Briefing: resdata.Briefing,
                Istrue: false,
                Stroc: resdata.Stroc,
                type: 2,
              };
              console.log(this.coursetypelistTwo, "测试");
              console.log(this.editForm);
              this.$nextTick(() => {
                this.$refs["editForm"].clearValidate();
              });
            }
          });
        return;
      }
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        Briefing: "",
        CourseTypeId: null,
        Name: "",
        Detail: "",
        Detail_flow: "",
        IsStick: false,
        ListImg: "",
        Status: null,
        Stroc: 0,
      };

      this.$nextTick(() => {
        this.$refs["addForm"].clearValidate();
      });
      // this.getcoursetypelist();
    },
    DialogDown() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    onOptionsyear() {
      if (this.addForm.Istrue == true) {
        return;
      }
      setTimeout(() => {
        this.Addwangeditor();
      }, 200);
    },
    Addwangeditor() {
      var c = document.getElementById("Add_container").innerHTML;
      console.log(c);
      if (c.length <= 0) {
        this.editor = new E("#Add_container");
        this.editor_details = new E("#Add_container_details");
        this.editor_flow = new E("#Add_container_flow");
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor_flow.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor_details.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.create();
        this.editor_flow.create();
        this.editor_details.create();
        this.editor.txt.html("");
        this.editor_flow.txt.html("");
        this.editor_details.txt.html("");
      }
      if (c != null) {
        this.editor.txt.html("");
        this.editor_flow.txt.html("");
        this.editor_details.txt.html("");
      }
    },
    Editwangeditor() {
      if (this.editForm.Istrue == true) {
        return;
      }
      var c = document.getElementById("Edit_container").innerHTML;
      //console.log(c);
      if (c == null || c.length <= 0) {
        this.editor = new E("#Edit_container");
        this.editor_details = new E("#Edit_container_details");
        this.editor_flow = new E("#Edit_container_flow");
        this.editor.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor_flow.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor_details.config.uploadImgServer = "/api/Img/UploadFiles";
        this.editor.create();
        this.editor_flow.create();
        this.editor_details.create();
        console.log(this.editForm);
        if (this.isLine && !this.isCourse) {
          this.editor.txt.html(this.editForm.Detail);
        } else if (!this.isLine) {
          this.editor_details.txt.html(this.editForm.Detail);
          this.editor_flow.txt.html(this.editForm.Notice);
        }
      }
      if (c != null) {
        if (this.isLine && !this.isCourse) {
          this.editor.txt.html(this.editForm.Detail);
        } else if (!this.isLine) {
          this.editor_details.txt.html(this.editForm.Detail);
          this.editor_flow.txt.html(this.editForm.Notice);
        }
      }
    },
    editNewSubmit() {
      if (this.isLine && this.isCourse) {
        // 课程
        this.addForm.Istrue = true;
        this.editSubmit();
      } else if (this.isLine && !this.isCourse) {
        //文章
        if (this.editor != null) {
          this.addForm.Detail = this.editor.txt.html();
        }
        this.addForm.Istrue = false;
        this.editSubmit();
      } else {
        if (this.editor_flow != null) {
          this.addForm.Detail_flow = this.editor_flow.txt.html();
          this.activitiesedit();
        }
        //线下活动
      }
    },
    //编辑
    editSubmit: function () {
      if (this.editor != null) {
        this.editForm.Detail = this.editor.txt.html();
      }
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let para = Object.assign({}, this.editForm);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            console.log(para);
            ///课程
            if (this.editForm.Istrue) {
              backcourseupdate(para).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            } else {
              let ArticleeditForm = {
                Id: para.Id,
                Briefing: "",
                ArticleTypeId: para.CourseTypeId,
                Title: para.Name,
                Content: para.Detail,
                IsStick: false,
                ListImg: para.ListImg,
                ArticleStatus: para.Status,
                Stroc: Number(para.Stroc),
              };
              UpdateArticles(ArticleeditForm).then((res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            }
          });
        }
      });
    },
    addNewSubmit() {
      if (
        this.addForm.CourseHostTypeId == null ||
        this.coursetypelistTwo == null ||
        this.coursetypelistTwo <= 0 ||
        this.addForm.CourseHostTypeId <= 0
      ) {
        this.$message({
          message: "请选择专题或者类型",
          type: "error",
        });
        return;
      }
      if (this.isLine && this.isCourse) {
        // 课程
        this.addForm.Istrue = true;
        this.addSubmit();
      } else if (this.isLine && !this.isCourse) {
        //文章
        if (this.editor != null) {
          this.addForm.Detail = this.editor.txt.html();
        }
        this.addForm.Istrue = false;
        this.addSubmit();
      } else {
        if (this.editor_flow != null) {
          this.addForm.Detail_flow = this.editor_flow.txt.html();
          this.activitiesadd();
        }
        //线下活动
      }
    },
    // 新增活动
    activitiesadd() {
      let para = Object.assign({
        Name: this.addForm.Name,
        ListImg: this.addForm.ListImg,
        Notice: "",
        Maxmember: 0,
        Address: this.address,
        Status: this.addForm.Status,
        ActivityTypeId: this.addForm.CourseTypeId,
        Stroc: this.addForm.Stroc,
      });
      para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
      para.ModifyTime = para.CreateTime;
      para.Detail = this.editor_details.txt.html();
      para.Notice = this.editor_flow.txt.html();
      // para.ApplyStartDateTime =
      // this.addForm.ApplyStartDate + " " + this.addForm.ApplyStartTime;
      // para.StartDateTime =
      //   this.addForm.StartDate + " " + this.addForm.StartTime;
      // para.EndDateTime = this.addForm.EndDate + " " + this.addForm.EndTime;
      var user = JSON.parse(window.localStorage.user);
      if (user && user.uID > 0) {
        para.CreateId = user.uID;
        para.CreateBy = user.uRealName;
      } else {
        this.$message({
          message: "用户信息为空，先登录",
          type: "error",
        });
        _this.$router.replace(
          _this.$route.query.redirect ? _this.$route.query.redirect : "/"
        );
      }
      console.log(para);
      activitiesadd({ data: para, Stroc: para.Stroc }).then((res) => {
        if (util.isEmt.format(res)) {
          this.addLoading = false;
          return;
        }
        if (res.data.success) {
          this.AddRecordInfo("新增", "课程管理-新增课程列表");

          this.addLoading = false;
          //NProgress.done();
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.$refs["addForm"].resetFields();
          this.addFormVisible = false;
          this.getLists();
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    activitiesedit() {
      this.editForm.Detail = this.editor_details.txt.html();
      this.editForm.Notice = this.editor_flow.txt.html();
      console.log(this.editForm);
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            let datanew = {
              ...this.editForm,
              ActivityTypeId: this.editForm.CourseTypeId,
            };
            let para = Object.assign({}, datanew);
            para.ModifyTime = util.formatDate.format(new Date(), "yyyy-MM-dd");

            // console.log(para);
            activitiesedit({ data: para, Stroc: para.Stroc, Type: 2 }).then(
              (res) => {
                if (util.isEmt.format(res)) {
                  this.editLoading = false;
                  return;
                }
                if (res.data.success) {
                  this.editLoading = false;
                  //NProgress.done();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["editForm"].resetFields();
                  this.editFormVisible = false;
                  this.getLists();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              }
            );
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      if (!this.isCourse) {
        this.addForm.Detail = this.editor.txt.html();
      }
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            let para = Object.assign({}, this.addForm);
            para.CreateTime = util.formatDate.format(new Date(), "yyyy-MM-dd");
            para.ModifyTime = para.CreateTime;
            var user = JSON.parse(window.localStorage.user);
            if (user && user.uID > 0) {
              para.CreateId = user.uID;
              para.CreateBy = user.uRealName;
            } else {
              this.$message({
                message: "用户信息为空，先登录",
                type: "error",
              });
              _this.$router.replace(
                _this.$route.query.redirect ? _this.$route.query.redirect : "/"
              );
            }

            addcourses(para).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }
              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getLists();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  mounted() {
    this.getLists();
    this.GetHostCoursesData();
    // this.getcoursetypelist();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.operationBox {
  display: flex;
  flex-wrap: wrap;
}
.operationBox > div {
  display: flex;
  align-items: center;
}
.operationBox > div > p {
  margin-top: 0;
  margin-bottom: 10px;
  margin-left: 30px;
}
.btnBox {
  padding-left: 50px;
  width: 150px;
  justify-content: space-between;
  display: flex;
  padding-bottom: 10px;
}
</style>
